import React, { useEffect, useState } from "react";
import { AiOutlineFileGif } from "react-icons/ai";
import { IoIosSettings } from "react-icons/io";
import { IoTrashSharp } from "react-icons/io5";
// import { MdEditRoad } from "react-icons/md";
import { useHistory, useParams } from "react-router-dom";
import NewFormWizard from "../../components/formWizard/NewFormWizard";
import NewFormWizardChild from "../../components/formWizard/NewFormWziardChild";
import Layout from "../../components/layouts/Layout";
import http, { URL_S3 } from "../../config/BaseUrl";
import GifModal from "../events/components/Modal/GifModal";
import GifSettingsModal from "../events/components/Modal/GifSettingsModal";
import GIFEditTabs from "./components/Gif/GIFEditTabs";
import EditorProvider from "../../components/CanvasEditor/Context/EditorProvider";
const GifEdit = () => {
  const history = useHistory();
  const { id } = useParams();

  const [selectGifItems, setSelectGifItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [gifId, setGifId] = useState(null);
  const [gifEditOpen, setGifEditOpen] = useState(false);
  const [selectedSettings, setSelectedSettings] = useState(null);
  const [gifTemplateErr, setGifTemplateErr] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [frame, setFrame] = useState(null);
  const [selectedFrame, setSelectedFrame] = useState([])

  useEffect(() => {
    http
      .get(`gif-setting/${id}`)
      .then((res) => {
        let responseData = [];
        res.data.gifSetting.length > 0 &&
          res.data.gifSetting.forEach((item) => {
            responseData.push({
              id: item.gif_id,
              photo: item.photo,
              image: item.gif.preview_image,
              settings: item.gif_settings,
              custom_frame: item.gif.custom_frame.length > 0 ? item.gif.custom_frame[0] : null
            });
          });
        setSelectGifItems(responseData);
        setSelectedFrame(responseData);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, []);

  const handelSubmitGif = (e) => {
    e.preventDefault();
    if (selectGifItems.length > 0) {
      setLoading(true);
      http
        .post(`/event/gif-setting/update/${id}`, {
          gif_setting: selectGifItems,
          eventId: id,
        })
        .then((res) => {
          history.push(`/show/event/${id}`, "Information Updated.");
          setLoading(false);
        })
        .catch();
    } else {
      setGifTemplateErr(true);
    }
  };

  const setGifByProps = (data) => {
    setSelectGifItems(data);
    setSelectedFrame(data);
    setGifTemplateErr(false);
  };

  const removeProps = (id) => {
    let copyProps = [...selectGifItems];
    copyProps.splice(id, 1);
    setSelectGifItems(copyProps);
    setSelectedFrame(copyProps);
  };

  const submitTrigger = (data) => {
    let copyData = [...selectGifItems];

    let indexItem = copyData.findIndex((item) => item.id == data.gifId);

    if (indexItem >= 0) {
      copyData[indexItem]["settings"] = data;
    }

    setSelectGifItems(copyData);
  };

  const settingsOpen = (item) => {
    setOpenModal(true);
    setGifId(item.id);
    setFrame(item);
    setSelectedSettings(item.settings);
  };



  const openEditGif = (item) => {
    setGifEditOpen(true);
    setSelectedItem(item);
  };

  const closeEditGif = () => {
    setGifEditOpen(false);
    setSelectedItem(null);
  };

  const customFrame = (data, id) => {
    let frameData = [...selectedFrame]
    let dataIndex = frameData.findIndex(item => item.id === id)

    frameData[dataIndex].custom_frame = data
    setSelectedFrame([...frameData])
  }

  return (
    <Layout>
      <NewFormWizard />
      <NewFormWizardChild />
      <form onSubmit={handelSubmitGif}>
        <section className="mt-4">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="text-center col-12 col-md-12">
                      <div className="">
                        <p className="mb-0 display-4 text-primary event-form-title">
                          3 in 1 Animation Chooser
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-2 mb-3 row justify-content-center">
            <div className="col-md-10">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <AiOutlineFileGif size={30} />
                      <p className="mb-0 ml-2 font-size-16">
                        Animation Library
                      </p>
                    </div>

                    <div className="float-right">
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        data-toggle="modal"
                        data-target="#props-filter-modal"
                      >
                        Select 3 in 1 Animation
                      </button>
                      <GifModal
                        setData={setGifByProps}
                        selectGifItems={selectGifItems}
                      />
                    </div>
                  </div>
                  {gifTemplateErr && (
                    <p
                      className={`pt-2 mb-0 text-danger font-weight-bold text-right fade ${
                        gifTemplateErr ? "show" : "hide"
                      }`}
                    >
                      Choose any animation{" "}
                    </p>
                  )}
                  <div className="prop__area">
                    <div className="flex-wrap props-list d-flex">
                      {selectGifItems.length > 0 ? (
                        selectGifItems.map((propItem, index) => (
                          <div
                            className="prop__item"
                            key={`digital-props-index-${index}`}
                          >
                            <img
                              src={`${URL_S3}image/gif/preview_image/${propItem.image}`}
                              className="img-fluid"
                              alt="props-data"
                            />
                            {
                              propItem.custom_frame &&
                              <img 
                                  src={`${URL_S3}image/gif/frame_image/custom_frame/${propItem.custom_frame.frame}`} className="img-fluid" alt='no'
                                  style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', maxHeight: '150px', maxWidth: `150px`, objectFit: 'contain'}} 
                              />
                            }
                            <div className="remove-props d-flex justify-content-around align-items-center">
                              <span
                                className="font-small"
                                onClick={removeProps.bind(this, index)}
                              >
                                <IoTrashSharp />
                              </span>
                              {/* <span
                                className="font-small"
                                onClick={openEditGif.bind(this, propItem)}
                              >
                                <MdEditRoad />
                              </span> */}
                              <span
                                className="font-small"
                                onClick={settingsOpen.bind(this, propItem)}
                              >
                                <IoIosSettings />
                              </span>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="prop__no__item">
                          <h4>No 3 in 1 Animation Selected.</h4>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="my-5 row justify-content-center">
            <div className="col-md-10">
              <button
                type="submit"
                className="float-right px-5 btn btn-primary radius-10"
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Updating...
                  </>
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
          <GifSettingsModal
            isOpen={openModal}
            gifId={gifId}
            closeModal={setOpenModal}
            submitTrigger={submitTrigger}
            selectedSettings={selectedSettings}
            eventId={id}
            setSelectedFrame={setFrame}
            selectedFrame={frame}
            setCustomFrame={customFrame}
            canSetCustomFrame={true}
          />
          {gifEditOpen && (
            <EditorProvider>
              <GIFEditTabs item={selectedItem} closeItem={closeEditGif} />
            </EditorProvider>
          )}
        </section>
      </form>
    </Layout>
  );
};

export default GifEdit;
